export function getCheckoutUrl(bump1: boolean, bump2: boolean): string {
  if (bump1 && bump2) return 'https://manosquegeneran.com/cart/48303343403235:1'
  if (bump1) return 'https://manosquegeneran.com/cart/48303339340003:1'
  if (bump2) return 'https://manosquegeneran.com/cart/48303344222435:1'
  return 'https://manosquegeneran.com/cart/48283475017955:1'
}
